import { setupWorker } from 'msw'

export const EndPoints = []

export const worker = () => setupWorker(...EndPoints)
